import { APPOINTMENT_GUIDES_TITLE, getGuide, Route } from 'constants/'
import { useMatch } from 'react-router'

const matchPath = `${Route.APPOINTMENT_GUIDES}/*`

const useIsAppointmentGuidesRoute = () => Boolean(useMatch(matchPath))

/** The header title on Appointment Guides pages (the open guide's name), or undefined on any other route */
const useAppointmentGuidesTitle = () => {
  const match = useMatch(matchPath)

  if (!match) return undefined

  const [guideId] = (match.params['*'] ?? '').split('/')

  return getGuide(guideId)?.label ?? APPOINTMENT_GUIDES_TITLE
}

export { useAppointmentGuidesTitle, useIsAppointmentGuidesRoute }
